<template>
  <confirmation-dialog :action="submit" confirm-text="Сохранить и выйти" cancel-text="Продолжить редактирование">
    <template #activator>
      <e-btn :loading="loading" variant="primary">Сохранить</e-btn>
    </template>
    <div class="h3">Выход из режима редактирования</div>
    <div class="text-secondary mt-8">
      Варианты размещения, с которых сняли отметку выбора и все ограничения по ним будут удалены.
    </div>
  </confirmation-dialog>
</template>

<script setup lang="ts">
import ConfirmationDialog from '@/core/components/modals/ConfirmationDialog.vue';
import { EBtn } from '@/core/components/ui';

defineProps<{
  submit: () => Promise<void>;
  loading: boolean;
}>();
</script>

<style scoped lang="scss"></style>
